import React from "react";
import { IGame, GamesCollection } from "../interfaces/intefaces";
import { perPage } from "../config/consts";
import Game from "./Game";

interface IProps {
  games: GamesCollection | undefined,
  currentPage: number,
  setCurrentPage: (page:number) => void,
  userIsLoggedIn: boolean
  openModal: (game: IGame, for_fun: boolean) => void

}
declare const translations: { [key: string]: string }

const Games: React.FC<IProps> = ({ games, currentPage, setCurrentPage, userIsLoggedIn, openModal }) => {

  const handleGameClick = (game: IGame, loginRequired: boolean = true, for_fun:boolean = false) => {
    if (!userIsLoggedIn && loginRequired) {
      const el = document.getElementById('login-button')
      if (el !== null) {
        el.click();
      }
      return false;
    }
    openModal(game, for_fun);

    return true;
  }
  return (
    <>
      <div className="games-inner">
        <div className="games">
          {(games !== undefined) && games.games.map(game => {
            return (
              <Game game={game} key={game.id} handleGameClick={handleGameClick} />
            )
          }
          )}
        </div>

        {(games && currentPage * perPage <= games.count)
          && (
            <div className="text-center">
              <button type="button" className="btn-primary load_more" onClick={() => { setCurrentPage(currentPage + 1) }}>
                {translations.load_more}</button>
            </div>
          )}

        {(games && games.games.length == 0) && (
          <div className="no-results text-center">{translations.no_results}</div>
        )}
      </div>
    </>
  );
}

export default Games;